import ufeApi from 'services/api/ufeApi';
import cookieUtils from 'utils/Cookies';

//https://confluence.sephora.com/wiki/display/ILLUMINATE/Get+BI+Profile+API

function getBiProfile(profileId) {
    let url = `/api/bi/profiles/${profileId}/beautyInsiderAccount`;
    const { enableProfileBIGroup = false } = Sephora.configurationSettings;

    if (enableProfileBIGroup && cookieUtils.isRCPSProfileBiGroupAPIEnabled()) {
        url = `/gway/v2/bi/profiles/${profileId}/beautyInsiderAccount`;
    }

    return ufeApi.makeRequest(url, { method: 'GET' }).then(data => (data.errorCode ? Promise.reject(data) : data));
}

export default getBiProfile;
